import { fromJS } from 'immutable';
import { REGRADE_SET_PAYLOAD, REGRADE_SET_SCORE_RECONCILIATION, REGRADE_TOGGLE_REGRADING_EDIT_MODE } from '@instructure/quiz-common';
var defaultState = fromJS({
  scoreReconciliation: 'new_score'
});
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case REGRADE_TOGGLE_REGRADING_EDIT_MODE:
      if (state.get('regradeEditModeKey') === action.payload) {
        return state.remove('regradeEditModeKey');
      } else {
        return state.set('regradeEditModeKey', action.payload);
      }
    case REGRADE_SET_SCORE_RECONCILIATION:
      return state.set('scoreReconciliation', action.payload);
    case REGRADE_SET_PAYLOAD:
      return state.set('regradingPayload', action.payload);
    default:
      return state;
  }
});